


































































import { Component, Prop, Vue } from "vue-property-decorator";
import { GenericReferral } from "@/types/types";
import ReferralComponent from "@/components/Referral.vue";

@Component({
  components: {
    referral: ReferralComponent,
  },
})
export default class ReferralList extends Vue {
  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: () => [] })
  referrals!: Array<GenericReferral>;

  @Prop({ default: null })
  futureReferrals!: Array<GenericReferral> | null;

  @Prop({ default: null })
  pastReferrals!: Array<GenericReferral> | null;

  @Prop({ default: false })
  enableResolveReferrals!: boolean;

  @Prop({ default: false })
  enableLinkPatient!: boolean;

  get isGrouped(): boolean {
    return this.futureReferrals !== null || this.pastReferrals !== null;
  }

  get noReferrals(): boolean {
    if (this.isGrouped) {
      return (
        !this.loading &&
        (this.futureReferrals || []).length === 0 &&
        (this.pastReferrals || []).length === 0
      );
    }
    return !this.loading && this.referrals.length === 0;
  }

  loadOnScroll(event: Event) {
    const el: Element | null = event.srcElement as Element;
    if (el) {
      const maxScrollTop: number = el.scrollHeight - el.clientHeight;
      const scrollHeightRemaining: number = maxScrollTop - el.scrollTop;

      if (scrollHeightRemaining <= 200 && !this.loading) {
        this.$emit("loadOnScroll");
      }
    }
  }

  clicked(referral: GenericReferral): void {
    this.$emit("clicked", referral);
  }

  clickedLinkPatient(referral: GenericReferral): void {
    this.$emit("clickedLinkPatient", referral);
  }

  clickedResolve(referral: GenericReferral): void {
    this.$emit("clickedReferralResolve", referral);
  }

  clickedAmbuFeedback(referral: GenericReferral): void {
    this.$emit("clickedAmbuFeedback", referral);
  }
}
